import { call, fork, put, takeEvery } from 'redux-saga/effects';
import searchWordToastMsg from '../../../constants/service/toastMsg/searchWordToastMsg';
import SearchWordApi from '../../../lib/api/searchWord/SearchWordApi';
import { searchWordActions } from './';
import toastMsg from '../../../lib/toastMsg';
import { excelDownLoad, reDirectPage } from '../../../lib/common';
import { _setResponseListForm, setRequestForm } from '../../../lib/common';
import { SEARCH_WORD_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';

function* fetchList() {
  /**
   *  [검색 키워드 리스트] 리스트 요청하기
   */
  yield takeEvery(searchWordActions.GET_SEARCH_WORD_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.getSearchWordList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.GET_SEARCH_WORD_LIST_REQUEST_SUCCESS);

      const data = {
        searchWordList: _setResponseListForm(result.data.searchWordList, result.data.totalCnt, payload),
      };

      yield put({ type: searchWordActions.GET_SEARCH_WORD_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.GET_SEARCH_WORD_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [검색 키워드 리스트] 엑셀 다운로드 요청하기
   */
  yield takeEvery(searchWordActions.GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.getSearchWordListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('검색 키워드 리스트', result.data.searchWordListExcelSheet);
    } catch (e) {
      toastMsg.error(searchWordToastMsg.GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, e);
    }
  });

  /**
   *  검색 키워드 상세 요청하기
   */
  yield takeEvery(searchWordActions.GET_SEARCH_WORD_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.getSearchWordDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.GET_SEARCH_WORD_DETAIL_REQUEST_SUCCESS);

      const data = {
        searchWordSave: {
          word: result.data.word,
          count: result.data.count,
          relatedKeywordList: result.data.relatedKeywordList,
          relatedKeywordSelectList: result.data.relatedKeywordSelectList,
        },
      };

      yield put({ type: searchWordActions.GET_SEARCH_WORD_DETAIL_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.GET_SEARCH_WORD_DETAIL_REQUEST_ERROR, e);
    }
  });

  /**
   *  키워드 체크하기
   */
  yield takeEvery(searchWordActions.CHECK_KEYWORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.checkKeyword, setRequestForm(payload));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        searchWordSave: {
          isDuplicateWord: result.data.isDuplicateWord,
        },
      };

      yield put({ type: searchWordActions.CHECK_KEYWORD_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.CHECK_KEYWORD_REQUEST_ERROR, e);
    }
  });

  /**
   *  검색 키워드 등록하기
   */
  yield takeEvery(searchWordActions.CREATE_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.createSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.CREATE_SEARCH_WORD_REQUEST_SUCCESS);

      /**
       *  검색 키워드 리스트로 이동
       */
      reDirectPage({
        path: SEARCH_WORD_LIST_URL_PATH,
      });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.CREATE_SEARCH_WORD_REQUEST_ERROR, e);
    }
  });

  /**
   *  검색 키워드 편집하기
   */
  yield takeEvery(searchWordActions.EDIT_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.editSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.EDIT_SEARCH_WORD_REQUEST_SUCCESS);

      /**
       *  검색 키워드 리스트로 이동
       */
      reDirectPage({
        path: SEARCH_WORD_LIST_URL_PATH,
      });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.EDIT_SEARCH_WORD_REQUEST_ERROR, e);
    }
  });

  /**
   *  검색 키워드 삭제 요청하기
   */
  yield takeEvery(searchWordActions.DELETE_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.deleteSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(searchWordToastMsg.DELETE_SEARCH_WORD_REQUEST_SUCCESS);

      /**
       *  검색 키워드 삭제 후
       *  검색 키워드 리스트 페이지로 이동
       */
      reDirectPage({
        path: SEARCH_WORD_LIST_URL_PATH,
      });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.DELETE_SEARCH_WORD_REQUEST_ERROR, e);
    }
  });

  /**
   *  연관 키워드 리스트 요청하기
   */
  yield takeEvery(searchWordActions.GET_RELATED_SEARCH_WORD_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(SearchWordApi.getRelatedSearchWordList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        relatedKeywordSelectList: result.data.relatedKeywordSelectList,
      };

      yield put({ type: searchWordActions.GET_RELATED_SEARCH_WORD_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(searchWordToastMsg.GET_RELATED_SEARCH_WORD_LIST_REQUEST_ERROR, e);
    }
  });
}

export default function* searchWordSaga() {
  yield fork(fetchList);
}
